import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

export default class AccessLogsProvider extends HttpRequest {
  getAccessLogs (query) {
    this.setHeader(getAuthToken())
    return this.getByPagination('/report-access-logs', query)
  }
}
